<ng-container>
  <div class="ribbon-collection">
    <form [formGroup]="documentForm">
      <div class="ribbon-collection-items first-row">
        <div class="ribbon-item-group left-group">
          <div class="ribbon-item-col">
            <mat-form-field appearance="fill" class="clrsgn-form-field document-switcher">
              <mat-label class="clrsgn-label text-color-primary">Switch Document</mat-label>
              <mat-select data-cy="documentSwitcherDropdown" [value]="docId" panelClass="document-switcher-panel" (selectionChange)="onDocumentSelected($event.value)">
                @for (doc of sortedDocuments; track doc.id) {
                  <mat-option [value]="doc.id">
                    <div class="doc-option-content">
                      <span class="doc-name" [title]="doc.name">{{ doc.name }}</span>
                      @if (documentNeedsAttention(doc.id)) {
                        <i class="fa-solid fa-triangle-exclamation needs-attention-icon"></i>
                      }
                    </div>
                  </mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>
          <div class="ribbon-item-col">
            <mat-form-field appearance="fill" class="clrsgn-form-field document-name-field">
              <mat-label for="documentName" class="clrsgn-label text-color-primary">Document Name</mat-label>
              <input
                matInput
                class="text-color-primary"
                formControlName="documentName"
                data-cy="documentName"/>
            </mat-form-field>
          </div>
          <div class="ribbon-item-col">
            <mat-form-field appearance="fill" class="clrsgn-form-field document-name-field">
              <mat-label for="documentType" class="clrsgn-label text-color-primary">Document Type</mat-label>
              <input
                matInput
                maxlength="32"
                class="text-color-primary"
                formControlName="documentType"
                data-cy="documentType"/>
            </mat-form-field>
          </div>
          <div class="ribbon-item-col">
            <mat-form-field appearance="fill" class="clrsgn-form-field document-name-field">
              <mat-label for="actionType" class="clrsgn-label text-color-primary">Action Type</mat-label>
              <input
                matInput
                type="text"
                formControlName="actionType"
                data-cy="actionType"/>
            </mat-form-field>
          </div>
        </div>
        <div class="ribbon-item-group">
          <div class="ribbon-item-col">
            <button
              type="button"
              class="btn-tertiary btn-exit"
              (click)="handleExitDocumentEditor()"
              ><span
              class="fas fa-arrow-right-from-bracket ribbon-button-icon"
            ></span>
            Exit Document Editor
          </button>
          </div>
        </div>
      </div>
      <div class="ribbon-collection-items second-row">
        <div class="ribbon-item-group left-group">
          <div class="ribbon-item-col">
            @if (documentNeedsAttention(docId)) {
              <div class="ribbon-item needs-attention-indicator">
                <i class="fa-solid fa-triangle-exclamation needs-attention-icon"></i>
                <span class="needs-attention-label">Needs Attention:</span>
                <span class="needs-attention-message" [title]="getCurrentDocViolationMessage()">{{ getCurrentDocViolationMessage() }}</span>
              </div>
            }
          </div>
        </div>
        <div class="ribbon-item-group right-group">
          <div class="ribbon-item-col">
            @if (reviewedBy) {
              <div class="ribbon-item reviewed-by-indicator">
                Reviewed By: {{ reviewedBy }}
              </div>
            }
            @if (requiresReview) {
              <div class="ribbon-item">
                <button
                  class="btn center btn-primary"
                  (click)="markAsReviewed()"
                  [disabled]="!(canDigitize$ | async)"
                  >
                  Mark as Reviewed
                </button>
              </div>
            }
          </div>
        </div>
      </div>
    </form>
  </div>
</ng-container>
